<div
  class="w-[100%] h-[80px] bg-[#ffffff] rounded-lg mb-4 flex justify-start items-center lg:text-[30px] md:text-[26px] text-[18px] text-[#1f1f1f] font-bold lg:ps-4 md:ps-4 sm:ps-4 ps-12">
  {{ title | truncate: 50 }}
</div>
